"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _coreMixins = require("@vfuk/core-mixins");
var inputElementSuggestions = (0, _styledComponents.css)(["", ""], function (_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(["input:-webkit-autofill::first-line{font-family:", ";", "}"], theme.baseFont.fontFamily, _coreMixins.typography.paragraph(2, false));
});
var _default = inputElementSuggestions;
exports["default"] = _default;